module.exports = __webpack_public_path__ + "img/dj.fb3cceb5.svg";